// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    width={64}
    height={60}
    viewBox="0 0 64 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={0.5}
      y={0.5}
      width={63}
      height={59}
      rx={3.5}
      fill="#FFE6ED"
      stroke="#E4E3E7"
    />
    <path
      d="M20.2205 16.6046L43.8788 16.5653V48.2605H20.2205V16.6046Z"
      fill="#FF73A9"
      stroke="#29292F"
      strokeWidth={0.263158}
      strokeMiterlimit={10}
    />
    <path
      d="M20.2216 40.9933C19.6763 45.6844 16.3171 45.6844 16.3171 45.6844H39.8995C39.8995 45.6844 43.8791 45.6844 43.8791 39.6373L20.2216 40.9933Z"
      fill="#FFD5E1"
      stroke="#29292F"
      strokeWidth={0.263158}
      strokeMiterlimit={10}
    />
    <path
      d="M20.2205 16.5669H43.8788V39.0596C43.8789 39.3167 43.8284 39.5714 43.73 39.8089C43.6317 40.0465 43.4875 40.2623 43.3057 40.4441C43.1239 40.6259 42.908 40.7701 42.6705 40.8685C42.4329 40.9668 42.1783 41.0174 41.9212 41.0172H20.2213L20.2205 16.5669Z"
      fill="#FCFBF7"
      stroke="#29292F"
      strokeWidth={0.263158}
      strokeMiterlimit={10}
    />
    <path
      d="M41.86 41.0174C41.86 41.0174 40.0035 41.0174 40.0035 38.5307H16.4202C16.4202 40.8226 18.2777 41.0183 18.2777 41.0183L41.86 41.0174Z"
      fill="#FF9DBE"
      stroke="#29292F"
      strokeWidth={0.263158}
      strokeMiterlimit={10}
    />
    <path
      d="M23.8523 23.6046H39.9279"
      stroke="#29292F"
      strokeWidth={0.263158}
      strokeMiterlimit={10}
    />
    <path
      d="M23.8523 29.7742H39.9279"
      stroke="#29292F"
      strokeWidth={0.263158}
      strokeMiterlimit={10}
    />
    <path
      d="M32.0393 20.5081H37.9568"
      stroke="#29292F"
      strokeWidth={0.263158}
      strokeMiterlimit={10}
    />
    <path
      d="M23.8335 20.5081H30.0656"
      stroke="#29292F"
      strokeWidth={0.263158}
      strokeMiterlimit={10}
    />
    <path
      d="M32.0393 26.6758H37.9568"
      stroke="#29292F"
      strokeWidth={0.263158}
      strokeMiterlimit={10}
    />
    <path
      d="M23.8423 26.6758H30.0655"
      stroke="#29292F"
      strokeWidth={0.263158}
      strokeMiterlimit={10}
    />
    <path
      d="M23.8792 35.9896C23.8792 35.9896 24.0481 33.0431 25.2707 32.9723C26.5309 32.9006 26.2005 35.2559 27.1849 35.4528C28.0726 35.6266 28.3355 33.5527 29.6449 33.6541C31.1095 33.7654 30.6274 35.6668 36.0524 35.4061"
      stroke="#F95396"
      strokeWidth={0.263158}
      strokeMiterlimit={10}
    />
    <path
      d="M25.3943 18.2134C22.2487 17.8988 22.8778 14.1242 25.0797 14.1242C26.9671 14.1242 27.4913 15.8018 26.9671 16.6406"
      stroke="#29292F"
      strokeWidth={0.264474}
    />
    <circle
      cx={25.3944}
      cy={18.2134}
      r={0.314556}
      fill="#29292F"
    />
    <path
      d="M32.469 18.2134C29.3234 17.8988 29.9525 14.1242 32.1544 14.1242C34.0418 14.1242 34.566 15.8018 34.0418 16.6406"
      stroke="#29292F"
      strokeWidth={0.264474}
    />
    <circle
      cx={32.4689}
      cy={18.2134}
      r={0.314556}
      fill="#29292F"
    />
    <path
      d="M39.5435 18.2134C36.3979 17.8988 37.027 14.1242 39.2289 14.1242C41.1162 14.1242 41.6405 15.8018 41.1162 16.6406"
      stroke="#29292F"
      strokeWidth={0.264474}
    />
    <circle
      cx={39.5433}
      cy={18.2134}
      r={0.314556}
      fill="#29292F"
    />
    <path
      d="M42.0888 9.54254C42.9725 9.57677 43.8072 9.98009 44.4092 10.6638C45.0113 11.3475 45.3314 12.2556 45.2993 13.1885C45.3152 12.7265 45.4172 12.2724 45.5994 11.8521C45.7816 11.4318 46.0405 11.0534 46.3612 10.7387C46.682 10.424 47.0583 10.1791 47.4688 10.018C47.8792 9.85682 48.3157 9.7826 48.7533 9.79956C48.3157 9.78276 47.8855 9.67512 47.4873 9.48279C47.0891 9.29046 46.7307 9.01721 46.4325 8.67864C46.1344 8.34007 45.9024 7.94281 45.7497 7.50957C45.597 7.07632 45.5267 6.61558 45.5428 6.15365C45.5269 6.61558 45.4249 7.06969 45.2427 7.49002C45.0605 7.91035 44.8016 8.28867 44.4809 8.60337C44.1601 8.91807 43.7838 9.16299 43.3733 9.32414C42.9629 9.48529 42.5264 9.5595 42.0888 9.54254Z"
      fill="white"
    />
    <path
      d="M41.8684 9.5344L42.0888 9.54254M42.0888 9.54254C42.9725 9.57677 43.8072 9.98009 44.4092 10.6638C45.0113 11.3475 45.3314 12.2556 45.2993 13.1885M42.0888 9.54254C42.5264 9.5595 42.9629 9.48529 43.3733 9.32414C43.7838 9.16299 44.1601 8.91807 44.4809 8.60337C44.8016 8.28867 45.0605 7.91035 45.2427 7.49002C45.4249 7.06969 45.5269 6.61558 45.5428 6.15365M45.2993 13.1885L45.2905 13.4211M45.2993 13.1885C45.3152 12.7265 45.4172 12.2724 45.5994 11.8521C45.7816 11.4318 46.0405 11.0534 46.3612 10.7387C46.682 10.424 47.0583 10.1791 47.4688 10.018C47.8792 9.85682 48.3157 9.7826 48.7533 9.79956M48.7533 9.79956L48.9737 9.80886M48.7533 9.79956C48.3157 9.78276 47.8855 9.67512 47.4873 9.48279C47.0891 9.29046 46.7307 9.01721 46.4325 8.67864C46.1344 8.34006 45.9024 7.94281 45.7497 7.50957C45.597 7.07632 45.5267 6.61558 45.5428 6.15365M45.5428 6.15365L45.5505 5.92105"
      stroke="#29292F"
      strokeWidth={0.163193}
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
    <path
      d="M47.5417 17.682C48.1308 17.7036 48.6873 17.9583 49.0886 18.3902C49.49 18.822 49.7035 19.3955 49.682 19.9847C49.6926 19.6929 49.7606 19.4061 49.8821 19.1407C50.0036 18.8752 50.1762 18.6363 50.39 18.4375C50.6038 18.2387 50.8547 18.084 51.1283 17.9823C51.402 17.8805 51.693 17.8336 51.9847 17.8443C51.693 17.8337 51.4062 17.7657 51.1407 17.6443C50.8752 17.5228 50.6363 17.3502 50.4375 17.1364C50.2388 16.9225 50.0841 16.6716 49.9823 16.398C49.8805 16.1244 49.8337 15.8334 49.8444 15.5416C49.8338 15.8334 49.7658 16.1202 49.6443 16.3857C49.5228 16.6511 49.3502 16.8901 49.1364 17.0888C48.9226 17.2876 48.6717 17.4423 48.398 17.5441C48.1244 17.6458 47.8334 17.6927 47.5417 17.682Z"
      fill="white"
    />
    <path
      d="M47.3948 17.6769L47.5417 17.682M47.5417 17.682C48.1308 17.7036 48.6873 17.9583 49.0886 18.3902C49.49 18.822 49.7035 19.3955 49.682 19.9847M47.5417 17.682C47.8334 17.6927 48.1244 17.6458 48.398 17.5441C48.6717 17.4423 48.9226 17.2876 49.1364 17.0888C49.3502 16.8901 49.5228 16.6511 49.6443 16.3857C49.7658 16.1202 49.8338 15.8334 49.8444 15.5416M49.682 19.9847L49.6762 20.1316M49.682 19.9847C49.6926 19.6929 49.7606 19.4061 49.8821 19.1407C50.0036 18.8752 50.1762 18.6363 50.39 18.4375C50.6038 18.2387 50.8547 18.084 51.1283 17.9823C51.402 17.8805 51.693 17.8336 51.9847 17.8443M51.9847 17.8443L52.1316 17.8502M51.9847 17.8443C51.693 17.8337 51.4062 17.7657 51.1407 17.6443C50.8752 17.5228 50.6363 17.3502 50.4375 17.1364C50.2388 16.9225 50.0841 16.6716 49.9823 16.398C49.8805 16.1244 49.8337 15.8334 49.8444 15.5416M49.8444 15.5416L49.8495 15.3947"
      stroke="#29292F"
      strokeWidth={0.163193}
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
    <path
      d="M11.6153 33.3906C12.1837 33.4115 12.7204 33.6572 13.1076 34.0737C13.4948 34.4903 13.7007 35.0436 13.68 35.6119C13.6903 35.3305 13.7559 35.0538 13.873 34.7977C13.9902 34.5416 14.1567 34.3111 14.363 34.1194C14.5692 33.9277 14.8113 33.7784 15.0752 33.6803C15.3392 33.5821 15.6199 33.5369 15.9013 33.5472C15.6199 33.537 15.3432 33.4714 15.0871 33.3542C14.8311 33.237 14.6006 33.0705 14.4088 32.8643C14.2171 32.658 14.0679 32.416 13.9697 32.152C13.8715 31.8881 13.8263 31.6073 13.8366 31.3259C13.8264 31.6074 13.7608 31.884 13.6436 32.1401C13.5265 32.3962 13.36 32.6267 13.1537 32.8184C12.9474 33.0102 12.7054 33.1594 12.4414 33.2575C12.1775 33.3557 11.8968 33.4009 11.6153 33.3906Z"
      fill="white"
    />
    <path
      d="M11.4736 33.3857L11.6153 33.3906M11.6153 33.3906C12.1837 33.4115 12.7204 33.6572 13.1076 34.0737C13.4948 34.4903 13.7007 35.0436 13.68 35.6119M11.6153 33.3906C11.8968 33.4009 12.1775 33.3557 12.4414 33.2575C12.7054 33.1594 12.9474 33.0102 13.1537 32.8184C13.36 32.6267 13.5265 32.3962 13.6436 32.1401C13.7608 31.884 13.8264 31.6074 13.8366 31.3259M13.68 35.6119L13.6744 35.7536M13.68 35.6119C13.6903 35.3305 13.7559 35.0538 13.873 34.7977C13.9902 34.5416 14.1567 34.3111 14.363 34.1194C14.5692 33.9277 14.8113 33.7784 15.0752 33.6803C15.3392 33.5821 15.6199 33.5369 15.9013 33.5472M15.9013 33.5472L16.043 33.5529M15.9013 33.5472C15.6199 33.537 15.3432 33.4714 15.0871 33.3542C14.8311 33.237 14.6006 33.0705 14.4088 32.8643C14.2171 32.658 14.0679 32.416 13.9697 32.152C13.8715 31.8881 13.8263 31.6073 13.8366 31.3259M13.8366 31.3259L13.8416 31.1842"
      stroke="#29292F"
      strokeWidth={0.163193}
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
  </svg>
);
const SvgLearningHubSpeakerNotes = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgLearningHubSpeakerNotes;
